import React from "react";

const getCount = (value) => {
  const number = Number(value);

  return Number.isFinite(number)
    ? Math.max(0, number)
    : 0;
};

const CashFlowSummaryCard = ({
  data,
  onClick,
  loading = false
}) => {
  const checkerCount = getCount(
    data?.totalCashPendingChecker
  );

  const accountsCount = getCount(
    data?.totalCashPendingAccounts
  );

  const totalCount = getCount(
    data?.totalCashPending ?? checkerCount + accountsCount
  );

  const items = [
    {
      key: "total",
      label: "Total Pending",
      value: totalCount,
      icon: "fa fa-list-alt",
      description: "Pending cash approvals",
      background:
        "linear-gradient(135deg, #ff9800, #f57c00)"
    },
    {
      key: "checker",
      label: "CashChecker Approval",
      value: checkerCount,
      icon: "fa fa-user",
      description: "Pending with CashChecker",
      background:
        "linear-gradient(135deg, #2196f3, #1565c0)"
    },
    {
      key: "accounts",
      label: "Accounts Approval",
      value: accountsCount,
      icon: "fa fa-check-square-o",
      description: "Pending with Accounts",
      background:
        "linear-gradient(135deg, #7e57c2, #5e35b1)"
    }
  ];

  return (
    <div
      className="card border-0 mb-3"
      aria-busy={loading}
      style={{
        borderRadius: "16px",
        background: "transparent",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)"
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center flex-wrap gap-2"
        style={{ padding: "10px 14px 3px" }}
      >
        <div>
          <h4
            className="mb-0"
            style={{
              fontSize: "17px",
              fontWeight: 700,
              color: "#212529"
            }}
          >
            Petty Cash Approvals
          </h4>

          <div
            className="mt-1"
            style={{
              color: "#6c757d",
              fontSize: "10px"
            }}
          >
            Overview of pending cash approvals
          </div>
        </div>

        <button
          type="button"
          className="btn btn-sm"
          onClick={onClick}
          style={{
            color: "#343a40",
            border: "1px solid #ced4da",
            borderRadius: "8px",
            padding: "5px 11px",
            fontSize: "11px",
            fontWeight: 600,
            boxShadow: "0 2px 6px rgba(0,0,0,0.06)"
          }}
        >
          View Details
        </button>
      </div>

      <div style={{ padding: "7px 12px 18px" }}>
        <div className="row g-2">
          {items.map((item) => (
            <div
              key={item.key}
              className="col-12 col-md-4"
            >
              <div
                style={{
                  height: "100%",
                  minHeight: "88px",
                  borderRadius: "11px",
                  padding: "10px",
                  border:
                    "1px solid rgba(255,255,255,0.28)",
                  boxShadow:
                    "0 6px 14px rgba(0,0,0,0.16)",
                  background: item.background,
                  color: "#fff"
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "50%",
                      background:
                        "rgba(255,255,255,0.20)",
                      flexShrink: 0
                    }}
                  >
                    <i
                      className={item.icon}
                      aria-hidden="true"
                      style={{
                        fontSize: "16px",
                        color: "#fff"
                      }}
                    />
                  </span>

                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: "21px",
                        fontWeight: 700,
                        lineHeight: 1,
                        color: "#fff",
                        overflowWrap: "anywhere"
                      }}
                    >
                      {loading
                        ? "…"
                        : item.value.toLocaleString("en-IN")}
                    </div>

                    <div
                      className="mt-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#fff"
                      }}
                    >
                      {item.label}
                    </div>
                  </div>
                </div>

                <div
                  className="mt-2"
                  style={{
                    fontSize: "9px",
                    fontWeight: 500,
                    lineHeight: "12px",
                    minHeight: "12px",
                    color: "rgba(255,255,255,0.90)"
                  }}
                >
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CashFlowSummaryCard;